// extracted by mini-css-extract-plugin
module.exports = {"cart":"styles_cart__G4sXR","empty":"styles_empty__2R_O9","container":"styles_container__3tzqD","product":"styles_product__3KCv6","disclaimer":"styles_disclaimer__25EHD"};